import { isEmpty } from 'lodash-es';
import { useTranslation } from '@frontend/i18n';
import { Heading } from '@frontend/design-system';
import { InsuranceReportPlanType } from '../../../types';
import { SectionInfo } from './SectionInfo';
import { insuranceDetailsContainerStyles, sectionInfoContainerStyles } from './styles';

type PlanDetailsProps = {
  plan: InsuranceReportPlanType;
  memberId?: string;
  groupNumber?: string;
  groupName?: string;
};

export const PlanDetails = ({ plan, memberId, groupName, groupNumber }: PlanDetailsProps) => {
  const { t } = useTranslation('insuranceEligibilityReport');

  if (isEmpty(plan)) return null;

  return (
    <div css={insuranceDetailsContainerStyles}>
      <Heading level={3}>{t('Plan Details')}</Heading>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Member ID')} value={memberId || '-'} />
        <SectionInfo label={t('Group Number')} value={plan?.groupNumber || groupNumber || '-'} />
        <SectionInfo label={t('Group Name')} value={plan?.groupName || groupName || '-'} />
      </div>
      <div css={sectionInfoContainerStyles}>
        <SectionInfo label={t('Plan Name')} value={plan?.name || '-'} />
        <SectionInfo label={t('Plan Type')} value={plan?.type || '-'} />
      </div>
    </div>
  );
};
